import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const _tok = typeof window !== "undefined" ? localStorage.getItem("wt_token") : null;
if (_tok) api.defaults.headers.common["Authorization"] = `Bearer ${_tok}`;

export const authedUrl = (path) => {
  const t = typeof window !== "undefined" ? localStorage.getItem("wt_token") : null;
  const sep = path.includes("?") ? "&" : "?";
  return `${API}${path}${t ? `${sep}token=${encodeURIComponent(t)}` : ""}`;
};

export const CURRENCY_OPTIONS = ["RM", "SGD", "USD", "IDR", "INR", "EUR", "GBP", "HKD", "CNY", "JPY", "AUD"];

// Backwards-compat: fmtMoney(n, digits) still works and defaults to "RM"
export const fmtMoney = (n, digits = 2) => fmtCur(n, "RM", digits);

// New: format with explicit currency
export const fmtCur = (n, currency = "RM", digits = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const sign = n < 0 ? "-" : "";
  const v = Math.abs(Number(n));
  return sign + (currency || "RM") + " " + v.toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits });
};

export const fmtNum = (n, digits = 0) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Number(n).toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits });
};

export const fmtPct = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return `${Number(n).toFixed(2)}%`;
};
